import useNavigations from './useNavigations';

export default useNavigations;
